// extracted by mini-css-extract-plugin
module.exports = {"root":"NatRulesIpInfo_root__2VrKj","verticalAlign":"NatRulesIpInfo_verticalAlign__3FKYT","targetField":"NatRulesIpInfo_targetField__1KNeO"};